const colors = {
  light: {
    chart: {
      primary: 'white',
      secondary: 'white',
      grid: '#93a1bd',
      tertiary: '#919EBA',
      up: 'var(--primary-color)',
      down: '#F1432F'
    }
  },
  dark: {
    chart: {
      primary: '#131722',
      //'#131722',
      secondary: '#131722',
      //"#131722",
      grid: '#354360',
      tertiary: '#919EBA',
      up: '#23ac50',
      down: '#F1432F'
    }
  }
}

const getBaseOptions = colorTheme => {
  if (colorTheme === 'light') {
    return {
      toolbar_bg: '#f4f9fc',
      loading_screen: {
        backgroundColor: '#f4f9fc'
      },
      overrides: {
        'paneProperties.backgroundType': 'solid',
        'paneProperties.background': '#f4f9fc',
        ['mainSeriesProperties.candleStyle.upColor']: '#03A66D',
        ['mainSeriesProperties.candleStyle.downColor']: '#e26363',
        ['mainSeriesProperties.candleStyle.borderUpColor']: '#03A66D',
        ['mainSeriesProperties.candleStyle.borderDownColor']: '#e26363',
        ['mainSeriesProperties.candleStyle.wickUpColor']: '#03A66D',
        ['mainSeriesProperties.candleStyle.wickDownColor']: '#e26363',
        ['mainSeriesProperties.areaStyle.color1']: 'rgb(0, 230, 230)',
        'mainSeriesProperties.areaStyle.linecolor': 'rgb(0, 230, 230)'
      },
      theme: 'Light'
    }
  }

  return {
    toolbar_bg: '#001e28',
    loading_screen: {
      backgroundColor: '#001e28'
    },
    overrides: {
      'paneProperties.backgroundType': 'solid',
      'paneProperties.background': '#001e28',
      ['mainSeriesProperties.candleStyle.upColor']: '#03A66D',
      ['mainSeriesProperties.candleStyle.downColor']: '#e26363',
      ['mainSeriesProperties.candleStyle.borderUpColor']: '#03A66D',
      ['mainSeriesProperties.candleStyle.borderDownColor']: '#e26363',
      ['mainSeriesProperties.candleStyle.wickUpColor']: '#03A66D',
      ['mainSeriesProperties.candleStyle.wickDownColor']: '#e26363',
      ['mainSeriesProperties.areaStyle.color1']: 'rgb(0, 230, 230)',
      'mainSeriesProperties.areaStyle.linecolor': 'rgba(0, 230, 230, 0.5)',

      // Removing Volume value in legend
      'paneProperties.legendProperties.showStudyTitles': false,
      'paneProperties.legendProperties.showStudyValues': false
    },
    theme: 'Dark'
  }
}

/**
 * Returns widget options for the given theme, merged with optional color overrides.
 * Overrides shape: { toolbar_bg?, pane_bg?, up_color?, down_color?, area_color? }
 * Used by ReactNativeMobileChart when URL query params provide custom colors.
 */
export const customWidgetOptionsWithOverrides = (colorTheme, overrides) => {
  const base = getBaseOptions(colorTheme)
  if (!overrides || Object.keys(overrides).length === 0) {
    return base
  }

  const result = { ...base }
  const overrideKeys = { ...base.overrides }

  if (overrides.toolbar_bg !== null && overrides.toolbar_bg !== undefined) {
    result.toolbar_bg = overrides.toolbar_bg
    result.loading_screen = { ...base.loading_screen, backgroundColor: overrides.toolbar_bg }
  }
  if (overrides.pane_bg !== null && overrides.pane_bg !== undefined) {
    result.loading_screen = {
      ...(result.loading_screen || base.loading_screen),
      backgroundColor: overrides.pane_bg
    }
    overrideKeys['paneProperties.backgroundType'] = 'solid'
    overrideKeys['paneProperties.background'] = overrides.pane_bg
  }
  if (overrides.up_color !== null && overrides.up_color !== undefined) {
    overrideKeys['mainSeriesProperties.candleStyle.upColor'] = overrides.up_color
    overrideKeys['mainSeriesProperties.candleStyle.borderUpColor'] = overrides.up_color
    overrideKeys['mainSeriesProperties.candleStyle.wickUpColor'] = overrides.up_color
  }
  if (overrides.down_color !== null && overrides.down_color !== undefined) {
    overrideKeys['mainSeriesProperties.candleStyle.downColor'] = overrides.down_color
    overrideKeys['mainSeriesProperties.candleStyle.borderDownColor'] = overrides.down_color
    overrideKeys['mainSeriesProperties.candleStyle.wickDownColor'] = overrides.down_color
  }
  if (overrides.area_color !== null && overrides.area_color !== undefined) {
    overrideKeys['mainSeriesProperties.areaStyle.color1'] = overrides.area_color
    overrideKeys['mainSeriesProperties.areaStyle.linecolor'] = overrides.area_color
  }

  result.overrides = overrideKeys
  return result
}

export const customWidgetOptions = colorTheme => getBaseOptions(colorTheme)
